/* ------------------------------------------------------------------
   VideoCreditsPage.js       /dashboard/video-credits
   Buy extra VIDEO-credit packs – React-Bootstrap 5 / React 18
------------------------------------------------------------------ */
import React, { useState, useEffect, useContext } from 'react';
import { Card, Button, Row, Col, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { UserContext } from '../../../context/UserContext';

const API_BASE = '/api';

/* -------------- define your video packs here -------------------- */
const PACKS = [
  { credits: 10,  price: 10,  label:'Starter', savings:'' },
  { credits: 25,  price: 20,  label:'Booster', savings:'Save 12%' },
  { credits: 50,  price: 35,  label:'Pro',     savings:'Save 20%' },
];

export default function VideoCreditsPage () {
  const { usage } = useContext(UserContext) ?? {};

  const [selected, setSelected] = useState(PACKS[0]);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  /* handle ?status=success after Stripe redirect */
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    if (p.get('status')==='success') {
      p.delete('status');
      window.history.replaceState({},'',window.location.pathname);
      window.location.reload();
    }
  }, []);

  const buyCredits = async () => {
    try {
      setLoading(true); setError('');
      const { data } = await axios.post(
        `${API_BASE}/billing/video-credits/buy`,
        { credits:selected.credits },   // backend distinguishes by type
        { withCredentials:true }
      );
      window.location = data.url;      // Stripe Checkout
    } catch (e) {
      console.error(e);
      setError(e.response?.data?.error || 'Checkout failed');
      setLoading(false);
    }
  };

  const remaining = usage?.video?.left;

  return (
    <div className='container py-4'>
      <h2 className='mb-3'>Purchase extra Video Credits</h2>

      {remaining !== undefined &&
        <p className='text-muted'>Current balance:&nbsp;
          <strong>{remaining}</strong>&nbsp;credits
        </p>}

      {error && <Alert variant='danger'>{error}</Alert>}

      <Row xs={1} md={3} className='g-4'>
        {PACKS.map(p => (
          <Col key={p.credits}>
            <Card border={selected===p?'primary':'light'} className='h-100 shadow-sm'
                  style={{cursor:'pointer'}} onClick={()=>setSelected(p)}>
              <Card.Body className='d-flex flex-column align-items-center'>
                <h5 className='fw-bold mb-1'>{p.label}</h5>
                {p.savings && <span className='badge bg-success mb-2'>{p.savings}</span>}
                <h1 className='display-6 mb-0'>{p.credits}</h1>
                <span className='text-muted'>credits</span>
                <hr style={{width:'60%'}}/>
                <h4 className='fw-bold mb-0'>${p.price}</h4>
                <span className='text-muted'>
                  ${(p.price/p.credits).toFixed(2)} per credit
                </span>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className='d-flex justify-content-end mt-4'>
        <Button variant='primary' size='lg'
                disabled={loading} onClick={buyCredits}>
          {loading
            ? <Spinner animation='border' size='sm'/>
            : `Buy ${selected.credits} Credits – $${selected.price}`}
        </Button>
      </div>
    </div>
  );
}
